import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useLocation } from "react-router-dom";
import Layout from "@/_LayoutsRelated/layout/Layout";
import NewPostView from "@/pages/post/PostViewComponents/NewPostView";
import useApi from "@hooks/useApi";
import { api__getNewPostViewData } from "@/apis/posts/getNewPostViewData";
import { extractPostId } from "@/utils/GlobalJavascriptFunction";
import Loader from "@componentsShared/Loader/Loader";
var CarInfo = function CarInfo() {
  var _location$state;
  var location = useLocation();
  var postId = extractPostId(location.pathname);
  var _useApi = useApi([postId], function () {
      return api__getNewPostViewData(postId);
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    postDetails = _useApi2[2];
  if (loading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    headHideLinks: true,
    disableLoader: true,
    authenticationMsg: true,
    tracking: true //enable for showing tracking with back header
    ,
    hasWebviewClose: true
  }, /*#__PURE__*/React.createElement(NewPostView, {
    postData: postDetails,
    isTrackingView: true,
    financeView: true,
    screen_view_referral: location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.screen_view_referral
  }));
};
export default CarInfo;